import { Link } from 'react-router-dom';
import { useFormatting, useTranslation } from '../../../i18n/i18n';
import { ActiveOrderData } from '../../../types';
import './ActiveOrder.css';

interface ActiveOrderProps {
	order: ActiveOrderData;
}

export const ActiveOrder = ({ order }: ActiveOrderProps) => {
	const maxImagesToShow = order.items.length > 4 ? 3 : 4;
	const imagesToShow = order.items.slice(0, maxImagesToShow);
	const extraCount = order.items.length - imagesToShow.length;
	const showExtraCount = extraCount > 0;
	const productPreviewCellCount = imagesToShow.length + (showExtraCount ? 1 : 0);
	const { asPrice, dateTimeFormat } = useFormatting();
	const routes = useTranslation().routes;
	const t = useTranslation().orderPages;

	return (
		<div className="active-order">
			<div className="order-content">
				{productPreviewCellCount > 0 && (
					<div className={`product-preview product-preview--${productPreviewCellCount}`}>
						{imagesToShow.map((item) => (
							<div className="product-preview-cell" key={item.id}>
								<img src={item.image} alt={item.product.name} className="product-preview-image" />
							</div>
						))}

						{showExtraCount && (
							<Link
								className="product-preview-cell product-preview-count"
								to={`${routes.yourOrders}/${order.id}`}
							>
								+{extraCount}
							</Link>
						)}
					</div>
				)}

				<div className="order-summary">
					<Link to={`${routes.yourOrders}/${order.id}`}>
						<div>{order.displayId}</div>
					</Link>
					<div>{dateTimeFormat(new Date(order.datePurchased))}</div>
					<div>
						{order.delivery.firstname} {order.delivery.lastname}
						<br />
						{order.delivery.city}
					</div>
					<div>{asPrice(order.totals)}</div>
					<div>{t.visibleOrderStatus[order.status.id]}</div>
				</div>
			</div>

			{/* mobile layout */}
			<div className="order-summary-mobile">
				<div className="header">
					<span>
						<strong>{t.orderNumber}</strong>: {order.displayId}
					</span>
					<span className="date">{dateTimeFormat(new Date(order.datePurchased))}</span>
				</div>

				<hr className="divider" />

				<div className="section">
					<div className="label">{t.recipient}</div>
					<div className="value">
						{order.delivery.firstname} {order.delivery.lastname}, {order.delivery.city}
					</div>
				</div>

				<div className="two-col">
					<div>
						<div className="label">{t.orderValue}</div>
						<div className="value price">{asPrice(order.totals)}</div>
					</div>
					<div>
						<div className="label">{t.products}</div>
						<div className="value">{order.items.length}</div>
					</div>
				</div>

				<div className="section">
					<div className="label">{t.status}</div>
					<div className="value">{order.status.name}</div>
				</div>
			</div>
		</div>
	);
};
